export default __webpack_public_path__ + "static/media/agote2_g.4d0de704.jpg";